const pageType =
  window.ShopifyAnalytics &&
  window.ShopifyAnalytics.meta &&
  window.ShopifyAnalytics.meta.page &&
  window.ShopifyAnalytics.meta.page.pageType;

if (pageType !== "cart") {
  let counter = 0;
  const interval = setInterval(() => {
    const footerPrice = document.querySelector(".abc");

    if (footerPrice) {
      handleTEBox();
      clearInterval(interval);
    } else {
      counter += 100;
      if (counter >= 10000) {
        clearInterval(interval);
      }
    }
  }, 100);
} else {
  let counter = 0;
  const interval = setInterval(() => {
    const vatInputWrapper = document.querySelector(
      ".bss-b2b-vat-input-wrapper"
    );

    if (vatInputWrapper) {
      handleTEBox();
      clearInterval(interval);
    } else {
      counter += 100;
      if (counter >= 10000) {
        clearInterval(interval);
      }
    }
  }, 100);
}

function handleTEBox() {
  const translations = BSS_B2B.te.teTranslations;
  const headerText = document.querySelector(
    ".bss-b2b-translation-vat-form_header_text"
  );
  if (headerText) {
    headerText.innerText = translations.form_header_text;
  }

  const subtitleText = document.querySelector(
    ".bss-b2b-translation-vat-form_subtitle_text"
  );
  if (subtitleText) {
    subtitleText.innerText = translations.form_subtitle_text;
  }

  const successMessages = [
    document.querySelector(".bss-b2b-translation-vat-form_success_message"),
    document.querySelector(".bss-b2b-translation-vat-form_success_message_uk"),
    document.querySelector(".bss-b2b-translation-vat-form_success_message_abn"),
    document.querySelector(".bss-b2b-translation-vat-form_success_message_gst"),
    document.querySelector(
      ".bss-b2b-translation-vat-form_success_message_us_ein"
    ),
  ];

  successMessages.forEach((msg, index) => {
    if (msg) {
      switch (index) {
        case 0:
          msg.innerText = translations.form_success_message || "";
          break;
        case 1:
          msg.innerText = translations.form_success_message_uk || "";
          break;
        case 2:
          msg.innerText = translations.form_success_message_abn || "";
          break;
        case 3:
          msg.innerText = translations.form_success_message_gst || "";
          break;
        case 4:
          msg.innerText = translations.form_success_message_us_ein || "";
          break;
      }
    }
  });

  const errorMessages = [
    document.querySelector(".bss-b2b-translation-vat-form_error_message"),
    document.querySelector(".bss-b2b-translation-vat-form_error_message_uk"),
    document.querySelector(".bss-b2b-translation-vat-form_error_message_abn"),
    document.querySelector(".bss-b2b-translation-vat-form_error_message_gst"),
    document.querySelector(
      ".bss-b2b-translation-vat-form_error_message_us_ein"
    ),
    document.querySelector(
      ".bss-b2b-translation-vat-form_validate_country_code_message"
    ),
  ];

  errorMessages.forEach((msg, index) => {
    if (msg) {
      switch (index) {
        case 0:
          msg.innerText = translations.form_error_message || "";
          break;
        case 1:
          msg.innerText = translations.form_error_message_uk || "";
          break;
        case 2:
          msg.innerText = translations.form_error_message_abn || "";
          break;
        case 3:
          msg.innerText = translations.form_error_message_gst || "";
          break;
        case 4:
          msg.innerText = translations.form_error_message_us_ein || "";
          break;
        case 5:
          msg.innerText = translations.form_validate_country_code_message || "";
          break;
      }
    }
  });
}

document.addEventListener("cart:rerendered", () => {
  if (BSS_B2B) {
    BSS_B2B.observer.cartSubject.listenCartCheckout();
  }
});

if (typeof BSS_B2B !== "undefined") {
    const loop = setInterval(() => {
        const aovCart = document.querySelector("#AOV-CDMinimal");
        if (aovCart) {
            clearInterval(loop);
            console.log('test', aovCart)
           const mutationObserver = new MutationObserver((mutations) => {
              mutations.forEach((mutation) => {
                  if (mutation.type === "attributes") {
                      const el = mutation.target;
         
                      if (el.classList?.contains("AOV-CDMinimal--open")) {
                        setTimeout(() => {
                          handleCartVisible();
                        }, 2000);
                      }
                  }
              });
          });
          
          mutationObserver.observe(aovCart, {
              attributes: true,
              subtree: true, 
              attributeFilter: ["class"],
          });
        }
    }, 1000);

    setTimeout(() => clearInterval(loop), 20000);
}

//function
async function handleCartVisible() {
    setTimeout(async () => {
        let cartList = BSS_B2B.shopData.cart.items;
        if (!cartList?.length) {
            cartList = await getCartItems();
            if (!cartList || cartList.length === 0) return;
        }
        bindCartAttributes(cartList);
    }, 1000);
}

function bindCartAttributes(cartList) {
    const aovCartItems = document.querySelectorAll(".AOV-CartDrawer-Content .AOV-CartDrawer-Item ,.AOV-CDMinimal__Content .AOV-CDMinimal__Item");
    console.log(aovCartItems)
    aovCartItems.forEach((rebuyCartItem, index) => {
        const item = cartList[index];
        const priceElement = rebuyCartItem.querySelector(".AOV-CartDrawer-ItemPrice-Wrapper, .AOV-CDMinimal__ItemPrice__FinalPrice");
        if (priceElement) {
            priceElement.setAttribute("bss-b2b-cart-item-key", item.key);
            priceElement.setAttribute("bss-b2b-final-line-price", "");
        }
    });

    const subTotal = document.querySelector(".AOV-CartDrawer-Subtotal__Price , .AOV-CDMinimal__Subtotal__PriceContainer");
    if (subTotal && !subTotal.hasAttribute("bss-b2b-cart-total-price")) {
        subTotal.setAttribute("bss-b2b-cart-total-price", "");
    }

    BSS_B2B.observer.cartSubject.notifyObserver("CartMutate", "CartPriceMutate");
    BSS_B2B.observer.cartSubject.listenCartCheckout();
}

async function getCartItems() {
  try {
      const res = await fetch("/cart", {
          method: "GET",
          headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
          },
      });
      const resJson = await res.json();
      return resJson.items;
  } catch (err) {
      console.error("Failed to fetch cart items", err);
      return [];
  }
}
